import React from "react";

import classnames from "classnames";
import PropTypes from "prop-types";

import Spacer from "../layouts/Spacer";

import styles from "./Divider.module.scss";

function Divider({ height, width, spacerSize, color }) {
  const dividerClasses = classnames(
    styles[height],
    styles[width],
    styles[color],
  );

  return (
    <>
      <Spacer size={spacerSize} />
      <div className={dividerClasses} />
      <Spacer size={spacerSize} />
    </>
  );
}

Divider.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  spacerSize: PropTypes.string,
  color: PropTypes.oneOf(["gray", "faint-grey"]),
};

Divider.defaultProps = {
  height: "height-default",
  width: "width-default",
  spacerSize: "x5",
  color: "gray",
};

export default Divider;
